import type { AdStatus } from "@ads/shared";

/** Single active/inactive toggle (US-F1). Active=1, Inactive=0; click flips it. */
export function StatusToggle({
  status,
  busy,
  onToggle,
}: {
  status: AdStatus;
  busy?: boolean;
  onToggle: (next: 0 | 1) => void;
}) {
  const active = status === 1;
  return (
    <button
      type="button"
      className={`status-toggle ${active ? "on" : "off"}`}
      disabled={busy}
      aria-pressed={active}
      aria-label={active ? "Active — click to deactivate" : "Inactive — click to activate"}
      onClick={() => onToggle(active ? 0 : 1)}
    >
      {active ? "Active" : "Inactive"}
    </button>
  );
}
